const services = [{
        id: 1,
        serviceName: "Free Shipping",
        imgLink: "https://i.ibb.co/SxVHf1N/istockphoto-183322339-612x612.jpg",
    },
    {
        id: 2,
        serviceName: "With Security",

        imgLink: "https://i.ibb.co/kXbMgp1/Fingerprint-Computer-Technology-Cyber-Security.jpg",
    },
    {
        id: 3,
        serviceName: "Best Offer",

        imgLink: "https://i.ibb.co/JQ64Rnm/A-Satisfied-Customer-Is-The-Best-Business-Strategy-of-All.jpg",
    },
    {
        id: 4,
        serviceName: "Best Quality",

        imgLink: "https://i.ibb.co/GJZjxMX/Gold-and-silver-stars-on-white-background.jpg",
    },
];
export { services };